// extracted by mini-css-extract-plugin
module.exports = {"icon":"_5053187","textWrapper":"_8a23bd7","navWrapper":"_ead1c74"};